module.exports = __webpack_public_path__ + "media/components/Application/Sponsors/Index/secretmuse-69e5eb13859b3c1f1614907890b52dd6.png";